<template>
  <base-input :type="inputType" label="Salasana" v-bind="$attrs">
    <template v-if="showIcon" #left>
      <key-icon size="1.5x" class="field-icon" aria-hidden="true" />
    </template>
    <template #right>
      <button
        :title="visibilityToggleLabel"
        type="button"
        aria-hidden="true"
        tabindex="-1"
        class="btn btn-tertiary h-full w-full justify-center p-0 text-text"
        @click="showPassword = !showPassword"
      >
        <component
          :is="eyeIcon"
          size="1.5x"
          aria-hidden="true"
        />
      </button>
    </template>
  </base-input>
</template>

<script>
import { EyeIcon, EyeOffIcon, KeyIcon } from '@bit/vekenkaluste.veke-ui.icons'
import BaseInput from '@bit/vekenkaluste.veke-ui.input'

export default {
  name: 'PasswordField',
  components: {
    BaseInput, EyeIcon, EyeOffIcon, KeyIcon
  },
  inheritAttrs: false,
  props: {
    showIcon: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      showPassword: false
    }
  },
  computed: {
    inputType() {
      return this.showPassword ? 'text' : 'password'
    },
    eyeIcon() {
      return this.showPassword ? 'eye-off-icon' : 'eye-icon'
    },
    visibilityToggleLabel() {
      return this.showPassword ? 'Piilota salasana' : 'Näytä salasana'
    }
  }
}
</script>
